// app/src/polyfills.ts
import { Buffer } from "buffer";

(window as any).Buffer = Buffer;
(window as any).global = window; // some libs expect global
